import { Toast } from "@/components/atoms/toast";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from "@/components/ui/dropdown-menu";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";

interface PriceToastDropdownProps {
  locale: Locales;
  showOnlyIcon?: boolean;
}

export function PriceToastDropdown({ locale, showOnlyIcon = true }: PriceToastDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="z-20 outline-none"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <Toast
            id="product-hero"
            type="info"
            onlyIcon={showOnlyIcon}
            className="min-[384px]:min-w-none h-fit w-fit max-w-none cursor-pointer py-2 shadow-none"
            title={__("Price on demand", locale)}
          />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent side="bottom" align="end" className="p-0">
        <Toast
          id="range-price-expanded"
          type="info"
          title={__("Price on demand", locale)}
          description={__(
            "This product requires a custom price. Festi will send you information after your quote.",
            locale
          )}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
